export default __webpack_public_path__ + "static/media/img1.8dacf5a6.jpg";